import { call, put, takeLatest } from "redux-saga/effects";
import PrecertificacionActions, {
  Types as PrecertificacionTypes
} from "../../stores/precertificacion/Actions";
import PrecertificacionService from "../../services/precertificacion/PrecertificacionService";
import AseguradoService from "../../services/asegurado/AseguradoService";
import AuthService from "../../services/auth/AuthService";
import ResponseCode from "../../services/ResponseCode";
import {
  getMontoTotalReclamado,
  getMontoTotalArs,
  getMontoTotalAfiliado
} from "../../containers/precertificacion/utils/PrecertificacionUtils";

function* getPrecertificacion(request) {
  const { numeroSesion } = request.payload;

  yield put(PrecertificacionActions.getPrecertificacionLoading());

  const precertificacionResponse = yield call(
    PrecertificacionService.consultarPrecertificacion,
    AuthService.handleRequestSession(request.payload, numeroSesion)
  );

  if (
    !precertificacionResponse?.respuesta ||
    precertificacionResponse?.respuesta?.codigo ===
      ResponseCode.SERVER_ERROR.code
  ) {
    yield put(
      PrecertificacionActions.getPrecertificacionFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: ResponseCode.SERVER_ERROR.message
      })
    );
    return;
  }

  if (
    precertificacionResponse?.respuesta?.mensaje !== ResponseCode.OK.message
  ) {
    yield put(
      PrecertificacionActions.getPrecertificacionFailure(
        precertificacionResponse?.respuesta
      )
    );
    return;
  }

  let dataPrecertificacion = precertificacionResponse?.data;

  const procedimientos = dataPrecertificacion?.precertificacion?.procedimientos;

  if (procedimientos?.length > 0) {
    dataPrecertificacion?.precertificacion?.procedimientos?.push({
      frecuencia: "Totales",
      montoARS: getMontoTotalArs(procedimientos),
      montoAfiliado: getMontoTotalAfiliado(procedimientos),
      montoReclamado: getMontoTotalReclamado(procedimientos)
    });
  }

  yield put(
    PrecertificacionActions.getPrecertificacionSuccess(dataPrecertificacion)
  );
}

function* confirmarPrecertificacion(request) {
  const { numeroSesion } = request.payload;

  yield put(PrecertificacionActions.confirmarPrecertificacionLoading());

  const afiliadoResponse = yield call(
    AseguradoService.consultarAsegurado,
    AuthService.handleRequestSession(request.payload, numeroSesion)
  );

  if (
    !afiliadoResponse?.respuesta ||
    afiliadoResponse?.respuesta?.codigo === ResponseCode.SERVER_ERROR.code
  ) {
    yield put(
      PrecertificacionActions.confirmarPrecertificacionFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: ResponseCode.SERVER_ERROR.message
      })
    );
    return;
  }

  if (afiliadoResponse?.respuesta?.codigo !== ResponseCode.OK.code) {
    yield put(
      PrecertificacionActions.confirmarPrecertificacionFailure(
        afiliadoResponse?.respuesta
      )
    );
    return;
  }

  const confirmacionResponse = yield call(
    PrecertificacionService.confirmarPrecertificacion,
    AuthService.handleRequestSession(request.payload, numeroSesion)
  );

  if (
    !confirmacionResponse?.respuesta ||
    confirmacionResponse?.respuesta?.codigo === ResponseCode.SERVER_ERROR.code
  ) {
    yield put(
      PrecertificacionActions.confirmarPrecertificacionFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: ResponseCode.SERVER_ERROR.message
      })
    );
    return;
  }

  if (
    confirmacionResponse?.respuesta?.mensaje?.toLocaleLowerCase() !==
    ResponseCode.OK.message?.toLocaleLowerCase()
  ) {
    yield put(
      PrecertificacionActions.confirmarPrecertificacionFailure(
        confirmacionResponse?.respuesta
      )
    );
    return;
  }

  yield put(
    PrecertificacionActions.confirmarPrecertificacionSuccess({
      autorizacion: confirmacionResponse?.data
    })
  );
}

function* cancelarPrecertificacion(request) {
  const { numeroSesion } = request.payload;

  yield put(PrecertificacionActions.cancelarPrecertificacionLoading());

  const cancelacionResponse = yield call(
    PrecertificacionService.cancelarPrecertificacion,
    AuthService.handleRequestSession(request.payload, numeroSesion)
  );

  if (
    !cancelacionResponse?.respuesta ||
    cancelacionResponse?.respuesta?.codigo === ResponseCode.SERVER_ERROR.code
  ) {
    yield put(
      PrecertificacionActions.cancelarPrecertificacionFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: ResponseCode.SERVER_ERROR.message
      })
    );
    return;
  }

  if (cancelacionResponse?.respuesta?.codigo !== 0) {
    yield put(
      PrecertificacionActions.cancelarPrecertificacionFailure(
        cancelacionResponse?.respuesta
      )
    );
    return;
  }

  yield put(
    PrecertificacionActions.cancelarPrecertificacionSuccess(cancelacionResponse)
  );
}

function* tiposSolicitudesPrecertificacion(request) {
  yield put(PrecertificacionActions.tiposSolicitudesPrecertificacionLoading());

  const response = yield call(
    PrecertificacionService.tiposSolicitudesPrecertificacion,
    request.payload
  );

  if (
    !response?.respuesta ||
    response?.respuesta?.codigo === ResponseCode.SERVER_ERROR.code
  ) {
    yield put(
      PrecertificacionActions.tiposSolicitudesPrecertificacionFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: ResponseCode.SERVER_ERROR.message
      })
    );
    return;
  }

  if (response?.respuesta?.codigo !== ResponseCode.OK.code) {
    yield put(
      PrecertificacionActions.tiposSolicitudesPrecertificacionFailure(
        response?.respuesta
      )
    );
    return;
  }

  yield put(
    PrecertificacionActions.tiposSolicitudesPrecertificacionSuccess(
      response?.data
    )
  );
}

function* crearPrecertificacion(request) {
  yield put(PrecertificacionActions.crearPrecertificacionLoading());

  const {
    numeroSesion,
    informacion,
    documentos,
    coberturas,
    afiliado,
    compania
  } = request.payload;

  const formData = new FormData();

  formData.append("compania", compania);
  formData.append("numeroSesion", numeroSesion);
  formData.append("tipoSolicitud", informacion.tipoSolicitud);
  formData.append("telefono", informacion.telefono);
  formData.append("correo", informacion.correo);
  formData.append("medicoPrescriptor", informacion.medicoPrescriptor);
  formData.append("diagnostico", informacion.diagnostico);
  formData.append("comentarios", informacion.comentarios);
  formData.append("numeroAsegurado", afiliado.numeroAsegurado);
  formData.append("numeroPlastico", afiliado.numeroPlastico);

  coberturas.forEach((cobertura, index) => {
    formData.append(`procedimientos[${index}][codigo]`, cobertura.id);
    formData.append(
      `procedimientos[${index}][codigoCobertura]`,
      cobertura.codigoCobertura
    );
    formData.append(
      `procedimientos[${index}][nombreCobertura]`,
      cobertura.nombreCobertura
    );
    formData.append(
      `procedimientos[${index}][tipoProcedimiento]`,
      cobertura.tipoProcedimiento
    );
  });

  documentos.forEach((doc, index) => {
    formData.append(`documentos[${index}][codigo]`, doc.documento);
    formData.append(
      `documentos[${index}][tipoProcedimiento]`,
      doc.tipoProcedimiento
    );
    formData.append(`Documentos[${index}].Archivo`, doc.archivo);
  });

  const response = yield call(
    PrecertificacionService.crearPrecertificacion,
    formData
  );

  if (
    !response?.respuesta ||
    response?.respuesta?.codigo === ResponseCode.SERVER_ERROR.code
  ) {
    yield put(
      PrecertificacionActions.crearPrecertificacionError({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: ResponseCode.SERVER_ERROR.message
      })
    );
    return;
  }

  yield put(
    PrecertificacionActions.crearPrecertificacionSuccess(response?.data)
  );
}

function* consultarPrecertificaciones(request) {
  yield put(PrecertificacionActions.consultarPrecertificacionesLoading());

  const response = yield call(
    PrecertificacionService.buscarPrecertificacion,
    request.payload
  );

  if (
    [ResponseCode.BAD_REQUEST.code, ResponseCode.NOT_FOUND.code].includes(
      response?.respuesta?.codigo
    )
  ) {
    yield put(
      PrecertificacionActions.consultarPrecertificacionesFailure({
        codigo: response.respuesta.codigo,
        mensaje: response?.respuesta?.mensaje
      })
    );
    return;
  }

  if (
    !response?.respuesta ||
    response?.respuesta?.codigo === ResponseCode.SERVER_ERROR.code
  ) {
    yield put(
      PrecertificacionActions.consultarPrecertificacionesFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: ResponseCode.SERVER_ERROR.message
      })
    );
    return;
  }

  yield put(
    PrecertificacionActions.consultarPrecertificacionesSuccess({
      precertificaciones: response?.data,
      paginacion: {
        totalRegistros: response?.paginacion?.totalRegistros || 0,
        paginaActual: response?.paginacion?.pagina || 1,
        totalPaginas: response?.paginacion?.totalPaginas || 0,
        registrosPorPagina: response?.paginacion?.tamanoPagina || 0
      }
    })
  );
}

function* consultarUnaPrecertificacion(request) {
  yield put(PrecertificacionActions.consultarUnaPrecertificacionLoading());

  const response = yield call(
    PrecertificacionService.buscarUnaPrecertificacion,
    request.payload
  );

  if (
    [ResponseCode.BAD_REQUEST.code, ResponseCode.NOT_FOUND.code].includes(
      response?.respuesta?.codigo
    )
  ) {
    yield put(
      PrecertificacionActions.consultarUnaPrecertificacionFailure({
        codigo: response.respuesta.codigo,
        mensaje: response?.respuesta?.mensaje
      })
    );
    return;
  }

  if (
    !response?.respuesta ||
    response?.respuesta?.codigo === ResponseCode.SERVER_ERROR.code
  ) {
    yield put(
      PrecertificacionActions.consultarUnaPrecertificacionFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: ResponseCode.SERVER_ERROR.message
      })
    );
    return;
  }

  yield put(
    PrecertificacionActions.consultarUnaPrecertificacionSuccess({
      precertificacion: response?.data
    })
  );
}

function* modificarPrecertificacion(request) {
  yield put(PrecertificacionActions.modificarPrecertificacionLoading());

  const { id, numeroSesion, informacion, documentos } = request.payload;

  const formData = new FormData();

  formData.append("numeroSesion", numeroSesion);
  formData.append("tipoSolicitud", informacion.tipoSolicitud);
  formData.append("telefono", informacion.telefono);
  formData.append("correo", informacion.correo);
  formData.append("medicoPrescriptor", informacion.medicoPrescriptor);
  formData.append("diagnostico", informacion.diagnostico);
  formData.append("comentarios", informacion.comentarios);

  documentos.forEach((doc) => {
    formData.append("Documentos", doc);
  });

  const response = yield call(
    PrecertificacionService.modificarPrecertificacion,
    id,
    formData
  );

  if (
    !response?.respuesta ||
    response?.respuesta?.codigo === ResponseCode.SERVER_ERROR.code
  ) {
    yield put(
      PrecertificacionActions.modificarPrecertificacionError({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: ResponseCode.SERVER_ERROR.message
      })
    );
    return;
  }

  if (!response?.data) {
    yield put(
      PrecertificacionActions.modificarPrecertificacionError({
        codigo: ResponseCode.BAD_REQUEST.code,
        mensaje: response?.respuesta?.mensaje
      })
    );
    return;
  }

  yield put(
    PrecertificacionActions.modificarPrecertificacionSuccess({
      respuesta: response?.respuesta?.mensaje
    })
  );
}

function* descargarVoucherPrecertificacion(request) {
  yield put(PrecertificacionActions.descargarVoucherPrecertificacionLoading());

  try {
    const response = yield call(
      PrecertificacionService.descargarVoucherPrecertificacion,
      request.payload
    );

    if (!response || response.status !== 200) {
      yield put(
        PrecertificacionActions.descargarVoucherPrecertificacionError({
          codigo: ResponseCode.SERVER_ERROR.code,
          mensaje: `Voucher para la precertificación con ID ${request.payload.numeroSolicitud} no está disponible aun. `
        })
      );
      return;
    }

    const contentDisposition =
      response.headers?.["content-disposition"] ||
      response.headers?.["Content-Disposition"];

    let filename = `voucher_${request.payload.numeroSolicitud}.pdf`;

    if (contentDisposition) {
      const filenameRegex = /filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i;
      const matches = contentDisposition.match(filenameRegex);
      if (matches) {
        const rawName = matches[1] || matches[2];
        try {
          filename = decodeURIComponent(rawName.replace(/['"]/g, ""));
        } catch (e) {
          filename = rawName.replace(/['"]/g, "");
        }
      }
    }

    const blobData =
      response.data instanceof Blob
        ? response.data
        : new Blob([response.data], {
            type:
              response.headers?.["content-type"] || "application/octet-stream"
          });

    if (typeof window !== "undefined") {
      const url = URL.createObjectURL(blobData);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    }

    yield put(
      PrecertificacionActions.descargarVoucherPrecertificacionSuccess({
        success: true
      })
    );
  } catch (error) {
    console.error("Error al descargar el voucher:", error);
    yield put(
      PrecertificacionActions.descargarVoucherPrecertificacionError({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: error?.message || "Error al descargar el voucher"
      })
    );
  }
}

const exportedArray = [
  takeLatest(PrecertificacionTypes.GET_PRECERTIFICACION, getPrecertificacion),
  takeLatest(
    PrecertificacionTypes.CONFIRMAR_PRECERTIFICACION,
    confirmarPrecertificacion
  ),
  takeLatest(
    PrecertificacionTypes.CANCELAR_PRECERTIFICACION,
    cancelarPrecertificacion
  ),
  takeLatest(
    PrecertificacionTypes.TIPOS_SOLICITUDES_PRECERTIFICACION,
    tiposSolicitudesPrecertificacion
  ),
  takeLatest(
    PrecertificacionTypes.CREAR_PRECERTIFICACION,
    crearPrecertificacion
  ),
  takeLatest(
    PrecertificacionTypes.CONSULTAR_PRECERTIFICACIONES,
    consultarPrecertificaciones
  ),
  takeLatest(
    PrecertificacionTypes.CONSULTAR_UNA_PRECERTIFICACION,
    consultarUnaPrecertificacion
  ),
  takeLatest(
    PrecertificacionTypes.MODIFICAR_PRECERTIFICACION,
    modificarPrecertificacion
  ),
  takeLatest(
    PrecertificacionTypes.DESCARGAR_VOUCHER_PRECERTIFICACION,
    descargarVoucherPrecertificacion
  )
];

export default exportedArray;
